export const initialRegion = "en"

export const listRegion = [
    { name: 'English', value: 'en' },
    // {name: 'Deutsch', value: 'de', disabled: true},
    { name: 'Français', value: 'fr' },
    // {name: '繁體中文', value: 'cn', disabled: true},
    // {name: 'Español', value: 'es', disabled: true},
]

export enum RegionActions {
    UPDATE = "UPDATE"
}

export interface RegionAction {
    type: RegionActions,
    payload: string
}

export const regionReducer = (state: string, action: RegionAction) => {
    const { type, payload } = action
    switch(type) {
        case RegionActions.UPDATE:
            return payload;
        default:
            return state
    }
}
